module.exports = __webpack_public_path__ + "static/media/centralAdminLogin.9d1f1357.mp4";